import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "upsell-video",
  styleUrls: ['./upsell-video.scss'],
  templateUrl: "./upsell-video.html",
  encapsulation: ViewEncapsulation.None
})
export class UpsellVideoComponent {
  @Input() videoID: string;
  @Input() videoPlayType = "Srn39R7Ve3";
  @Input() accountID = "6058004207001";

  constructor() {}

}
